import { Fragment } from 'react'
import { Field, useForm } from 'react-final-form'

import Button from 'common/components/button'
import { Add as AddIcon } from 'common/icons'

import FieldContent from './FieldContent'

const MAX_LANGUAGE_RULES_VALUES = 3

const LanguageOutputExamplesField = () => {
  const form = useForm()

  const formStateValues = form.getState().values.examples || [
    {
      exampleInput: '',
      exampleOutput: '',
    },
  ]

  const handleOnChange = ({
    value,
    index,
    field,
  }: {
    value: string
    index: number
    field: string
  }) => {
    const updatedValues = [...formStateValues]
    updatedValues[index][field] = value

    form.change('examples', updatedValues)
  }

  return (
    <Fragment>
      <div className="flex items-center justify-between mb-4">
        <p className="text-base-700 font-normal text-xs">
          Provide up to 3 examples to help shape the language output.
        </p>
        <Button
          variant="icon"
          size="medium"
          prefixIcon={<AddIcon isDefaultColor={false} size={4} />}
          disabled={formStateValues.length >= MAX_LANGUAGE_RULES_VALUES}
          onClick={() => {
            form.change(`examples`, [
              ...formStateValues,
              {
                exampleInput: '',
                exampleOutput: '',
              },
            ])
          }}
        >
          Add example
        </Button>
      </div>
      <div className="flex flex-col justify-between items-center mb-4 rounded-sm">
        <Field<string[]>
          name="examples"
          render={({ input, meta }) => {
            return (
              <>
                {formStateValues.map((inputValues, index: number) => {
                  return (
                    <FieldContent
                      key={`language-output-example-${index}`}
                      meta={meta}
                      onBlur={input.onBlur}
                      exampleInput={inputValues.exampleInput}
                      exampleOutput={inputValues.exampleOutput}
                      onChange={({ value, field }) => {
                        handleOnChange({
                          value,
                          index,
                          field,
                        })
                      }}
                      isDeleteDisabled={formStateValues.length === 1}
                      onDelete={() => {
                        form.change(
                          'examples',
                          formStateValues.length === 1
                            ? undefined
                            : formStateValues.filter((_, i) => i !== index)
                        )
                      }}
                    />
                  )
                })}
              </>
            )
          }}
        />
      </div>
    </Fragment>
  )
}

export default LanguageOutputExamplesField
